import React, { useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";

import {
  Modal,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
  Typography,
  Slider,
  Stack,
  FormGroup,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import { GetAll } from "../../../util/request/getAll";
import { conforms } from "lodash";
import { authPut } from "../../../util/request/authPut";

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}
console.log("try");
ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.node,
};

const iOSBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: "#007bff",
  height: 5,
  maxWidth: 400,
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    backgroundColor: "#fff",
    boxShadow: "0 0 2px 0px rgba(0, 0, 0, 0.1)",
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.1)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: iOSBoxShadow,
      },
    },
    "&:before": {
      boxShadow:
        "0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)",
    },
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 14,
    fontWeight: "normal",
    top: -6,
    // backgroundColor: "unset",
    backgroundColor: "#d4e7f5",

    color: theme.palette.text.primary,
    "&::before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: "#000",
      ...theme.applyStyles("dark", {
        color: "#fff",
      }),
    },
  },
  "& .MuiSlider-track": {
    border: "none",
    height: 5,
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    boxShadow: "inset 0px 0px 4px -2px #000",
    backgroundColor: "#d0d0d0",
  },
  ...theme.applyStyles("dark", {
    color: "#0a84ff",
  }),
}));

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export default function EditBookingModal(props) {
  const [open, setOpen] = useState(false);
  const [partyRoom, setPartyRoom] = useState([]);
  const [partyTheme, setPartyTheme] = useState(["Candyland Gummy Dragon"]);
  const [selectedValue, setSelectedValue] = useState({
    ...props.eventData.package,
  });

  const totalCost = useRef(props.eventData.total_cost);

  const [optionValue, setOptionValue] = useState({
    ...props.eventData.bookingDetail,
  });
  const [partyPage, setPartyPage] = useState(true);
  const [infoPage, setInfoPage] = useState(false);
  const [confirmationPage, setConfirmationPage] = useState(false);

  totalCost.current = (
    (optionValue.twenty_off
      ? selectedValue.price * 0.8
      : selectedValue.price * 1) +
    optionValue.add_numAdult_cost * 1 +
    optionValue.add_numKid_cost * 1 +
    optionValue.add_pizza_cost * 1 +
    optionValue.upgrade_gummy_dragon_cost * 1 +
    optionValue.upgrade_luxury_package_cost * 1 +
    optionValue.upgrade_unlimited_playtime_cost * 1 +
    optionValue.bring_own_food_cost * 1
  ).toFixed(2);

  const handleOpen = () => setOpen(true);
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      // Do not close on backdrop click
      return;
    }
    setOptionValue({ ...props.eventData.bookingDetail });
    setOpen(false);
    props.reFreshData();
  };

  const handlePackageChange = (event) => {
    setSelectedValue(JSON.parse(event.target.value));
  };

  React.useEffect(() => {
    async function getData() {
      const getPartyData = await GetAll({ subLink: "partypackage" });

      getPartyData.data.data
        ? setPartyRoom(getPartyData.data.data)
        : setPartyRoom([]);
    }
    if (open) {
      getData();
    }
  }, [open]);

  React.useEffect(() => {
    async function getData() {
      const getThemeData = await GetAll({ subLink: "theme" });

      getThemeData.data.data
        ? setPartyTheme(getThemeData.data.data)
        : setPartyTheme([]);
    }
    if (open) {
      getData();
    }
  }, [open]);

  const handleSubmit = async () => {
    let data = {
      package: { ...selectedValue },
      bookingDetail: { ...optionValue },
    };

    const validateFormData = Object.values({
      ...data.package,
      ...data.bookingDetail,
    }).every(
      (value) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        !(
          typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0
        )
    );
    if (validateFormData) {
      const result = await authPut({
        subLink: "booking",
        id: props.eventData._id,
        data: {
          ...data,
          total_cost: totalCost.current,
        },
      });
      if (result.status === "success") {
        props.reFreshData();

        setOpen(false);
      }
    }
  };

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleOpen}
        // sx={{ marginTop: "20px", marginBottom: "20px", maxWidth: "100px" }}
        startIcon={<EditIcon></EditIcon>}
      >
        Edit
      </Button>
      {open && (
        <div>
          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                boxShadow: 24,
                paddingX: 4,
                borderRadius: 2,
                width: { xs: "350px", sm: "500px", md: "800px", lg: "800px" },
                height: "90%",
                overflowY: "auto",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  position: "sticky",
                  top: "0px",
                  width: "calc(120%+36px)",
                  height: "50px",
                  marginX: -4,
                  backgroundColor: "white",
                  //   borderRadius: "20px",
                  borderBottom: "2px solid #54a6e0",
                  boxShadow: 1,
                  zIndex: 10,
                }}
              >
                <Box>
                  <Typography
                    variant="h6"
                    component="h2"
                    gutterBottom
                    sx={{
                      width: "fit-content",
                      padding: "5px",
                    }}
                  >
                    Booking
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => {
                    const r = window.confirm(
                      "The Form will Not be saved, continue?"
                    );
                    if (r) return handleClose();
                  }}
                >
                  <CloseIcon></CloseIcon>
                </IconButton>
              </Stack>
              <Box>
                <Typography
                  sx={{
                    //   border: "1px solid black",
                    padding: "5px",
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#0377d0",
                    color: "white",
                    marginTop: "15px",
                  }}
                >
                  Room options
                </Typography>

                <FormControl>
                  <RadioGroup
                    name="roomOption"
                    value={JSON.stringify(selectedValue)}
                    onChange={handlePackageChange}
                    sx={{ paddingLeft: "20px" }}
                  >
                    {partyRoom.length !== 0
                      ? partyRoom.map((r) => (
                          <FormControlLabel
                            key={r.package_name}
                            value={JSON.stringify(r)}
                            control={<Radio />}
                            label={`${r.package_name} (Max. ${r.max_kid})`}
                            disabled
                          />
                        ))
                      : ""}
                  </RadioGroup>
                </FormControl>
                <Stack>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel
                      id="demo-simple-select-standard-label"
                      sx={{ marginLeft: "20px" }}
                    >
                      Theme
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={optionValue.theme}
                      onChange={(e) => {
                        setOptionValue((prev) => ({
                          ...prev,
                          theme: e.target.value,
                        }));
                      }}
                      label="Theme"
                      sx={{ width: "200px", marginLeft: "20px" }}
                    >
                      {partyTheme.length !== 0
                        ? partyTheme.map((e) => (
                            <MenuItem key={e._id} value={e.party_theme}>
                              {e.party_theme}
                            </MenuItem>
                          ))
                        : ""}
                    </Select>
                  </FormControl>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    gutterBottom
                    sx={{ width: "100%", textAlign: "right" }}
                  >
                    +${selectedValue.price}
                  </Typography>
                </Stack>
                <Typography
                  sx={{
                    //   border: "1px solid black",
                    padding: "5px",
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#0377d0",
                    color: "white",
                  }}
                >
                  Number of Guests{" "}
                </Typography>

                <Stack mt={3} spacing={2} sx={{ marginLeft: "30px" }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignContent="center"
                  >
                    <Typography variant="subtitle1" component="h2" gutterBottom>
                      Children
                    </Typography>
                    <Typography variant="subtitle1" component="h2" gutterBottom>
                      +$
                      {optionValue.add_numKid_cost}
                    </Typography>
                  </Stack>
                  <IOSSlider
                    name="kidNum"
                    //   sx={{ width: "200px" }}
                    //   defaultValue={0}
                    valueLabelDisplay="on"
                    value={optionValue.num_kid}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        num_kid: e.target.value,
                        num_adult: 0,
                        add_numAdult_cost: 0,
                        add_numKid_cost:
                          selectedValue.add_per_kid_charge *
                            (e.target.value - selectedValue.kid_free) >
                          0
                            ? (
                                selectedValue.add_per_kid_charge *
                                (e.target.value - selectedValue.kid_free)
                              ).toFixed(2)
                            : 0,
                        upgrade_unlimited_playtime_cost:
                          prev.upgrade_unlimited_playtime
                            ? (5.99 * e.target.value).toFixed(2)
                            : 0,
                      }));
                    }}
                    step={1}
                    //   marks
                    min={0}
                    marks={[
                      {
                        value: selectedValue.kid_free,
                        label: `Free.${selectedValue.kid_free}`,
                      },
                      // {
                      //   value: selectedValue.max_kid,
                      //   label: `Max.${selectedValue.max_kid}`,
                      // },
                    ]}
                    max={selectedValue.max_kid}
                  />
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignContent="center"
                  >
                    <Typography variant="subtitle1" component="h2" gutterBottom>
                      Adults
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="h2"
                      gutterBottom
                      sx={{ width: "100%", textAlign: "right" }}
                    >
                      +$
                      {optionValue.add_numAdult_cost}
                    </Typography>
                  </Stack>
                  <IOSSlider
                    name="adultNum"
                    //   defaultValue={0}
                    //   sx={{ width: "400px" }}
                    value={optionValue.num_adult}
                    valueLabelDisplay="on"
                    // shiftStep={1}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        num_adult: e.target.value,
                        add_numAdult_cost:
                          selectedValue.add_per_adult_charge *
                            (e.target.value -
                              (selectedValue.adult_free +
                                ((optionValue.num_kid -
                                  selectedValue.kid_free) *
                                  1 >
                                0
                                  ? optionValue.num_kid - selectedValue.kid_free
                                  : 0))) >
                          0
                            ? (
                                selectedValue.add_per_adult_charge *
                                (e.target.value -
                                  (selectedValue.adult_free +
                                    ((optionValue.num_kid -
                                      selectedValue.kid_free) *
                                      1 >
                                    0
                                      ? optionValue.num_kid -
                                        selectedValue.kid_free
                                      : 0)))
                              ).toFixed(2)
                            : 0,
                      }));
                    }}
                    step={1}
                    marks={[
                      {
                        value:
                          selectedValue.adult_free +
                          ((optionValue.num_kid - selectedValue.kid_free) * 1 >
                          0
                            ? optionValue.num_kid - selectedValue.kid_free
                            : 0),
                        label: `Free.${
                          selectedValue.adult_free +
                          ((optionValue.num_kid - selectedValue.kid_free) * 1 >
                          0
                            ? optionValue.num_kid - selectedValue.kid_free
                            : 0)
                        }`,
                      },
                      // {
                      //   value: selectedValue.max_adult,
                      //   label: `Max.${selectedValue.max_adult}`,
                      // },
                    ]}
                    min={0}
                    max={selectedValue.max_adult}
                  />
                </Stack>
                <Typography
                  sx={{
                    marginTop: "30px",
                    padding: "5px",
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#0377d0",
                    color: "white",
                  }}
                >
                  Free Pizza x {selectedValue.free_pizza} (add $
                  {selectedValue.pizza_price} per pizza)
                </Typography>
                <Stack mt={3} spacing={3} sx={{ marginLeft: "30px" }}>
                  <Typography variant="subtitle1" component="h2" gutterBottom>
                    Pizza (cheese)
                  </Typography>

                  <IOSSlider
                    name="cheesePizza"
                    valueLabelDisplay="on"
                    value={optionValue.cheese_pizza}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        cheese_pizza: e.target.value,
                        add_pizza_cost:
                          selectedValue.pizza_price *
                            (e.target.value +
                              optionValue.pepperoni_pizza +
                              optionValue.veggie_pizza -
                              selectedValue.free_pizza) >
                          0
                            ? (
                                selectedValue.pizza_price *
                                (e.target.value +
                                  optionValue.pepperoni_pizza +
                                  optionValue.veggie_pizza -
                                  selectedValue.free_pizza)
                              ).toFixed(2)
                            : 0,
                      }));
                    }}
                    step={1}
                    //   marks
                    min={0}
                    marks
                    max={Math.ceil(selectedValue.max_kid / 2)}
                  />

                  <Typography variant="subtitle1" component="h2" gutterBottom>
                    Pizza (pepperoni)
                  </Typography>
                  <IOSSlider
                    name="pepperoniPizza"
                    //   defaultValue={0}
                    value={optionValue.pepperoni_pizza}
                    //  getAriaValueText={valuetext}
                    valueLabelDisplay="on"
                    // shiftStep={1}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        pepperoni_pizza: e.target.value,
                        add_pizza_cost:
                          selectedValue.pizza_price *
                            (optionValue.cheese_pizza +
                              e.target.value +
                              optionValue.veggie_pizza -
                              selectedValue.free_pizza) >
                          0
                            ? (
                                selectedValue.pizza_price *
                                (optionValue.cheese_pizza +
                                  e.target.value +
                                  optionValue.veggie_pizza -
                                  selectedValue.free_pizza)
                              ).toFixed(2)
                            : 0,
                      }));
                    }}
                    step={1}
                    marks
                    min={0}
                    max={Math.ceil(selectedValue.max_kid / 2)}
                  />
                  <Typography variant="subtitle1" component="h2" gutterBottom>
                    Pizza (veggie)
                  </Typography>
                  <IOSSlider
                    name="veggiePizza"
                    //   defaultValue={0}
                    value={optionValue.veggie_pizza}
                    valueLabelDisplay="on"
                    // shiftStep={1}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        veggie_pizza: e.target.value,
                        add_pizza_cost:
                          selectedValue.pizza_price *
                            (optionValue.cheese_pizza +
                              optionValue.pepperoni_pizza +
                              e.target.value -
                              selectedValue.free_pizza) >
                          0
                            ? (
                                selectedValue.pizza_price *
                                (optionValue.cheese_pizza +
                                  optionValue.pepperoni_pizza +
                                  e.target.value -
                                  selectedValue.free_pizza)
                              ).toFixed(2)
                            : 0,
                      }));
                    }}
                    step={1}
                    marks
                    min={0}
                    max={Math.ceil(selectedValue.max_kid / 2)}
                  />

                  <Typography
                    variant="subtitle1"
                    component="h2"
                    gutterBottom
                    sx={{ width: "100%", textAlign: "right" }}
                  >
                    +$
                    {(optionValue.add_pizza_cost * 1).toFixed(2)}
                  </Typography>
                </Stack>

                <Stack mt={3} spacing={3} sx={{ marginBottom: "20px" }}>
                  <Typography
                    sx={{
                      //   border: "1px solid black",
                      padding: "5px",
                      width: "100%",
                      borderRadius: "5px",
                      backgroundColor: "#0377d0",
                      color: "white",
                    }}
                  >
                    Upgrade{" "}
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={optionValue.upgrade_gummy_dragon}
                        onChange={(e) => {
                          setOptionValue((prev) => ({
                            ...prev,
                            upgrade_gummy_dragon: e.target.checked,
                            upgrade_gummy_dragon_cost: e.target.checked
                              ? 80
                              : 0,
                          }));
                        }}
                      />
                    }
                    label="Gummy Dragon come to celebrate in party room for an additional $80 (happy birthday song, hugs, and pics.)"
                  />
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    gutterBottom
                    sx={{ width: "100%", textAlign: "right" }}
                  >
                    +$
                    {(optionValue.upgrade_gummy_dragon_cost * 1).toFixed(2)}
                  </Typography>
                  {optionValue.upgrade_luxury_package && (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={optionValue.upgrade_luxury_package}
                            onChange={(e) => {
                              setOptionValue((prev) => ({
                                ...prev,
                                upgrade_luxury_package: e.target.checked,
                                upgrade_luxury_package_cost: e.target.checked
                                  ? 80
                                  : 0,
                              }));
                            }}
                          />
                        }
                        label="Luxury package for an additinal $80 ( balloon decoration including age, birthday hat & candle, and a special gift for birthday child.)"
                      />
                      <Typography
                        variant="subtitle1"
                        component="h2"
                        gutterBottom
                        sx={{ width: "100%", textAlign: "right" }}
                      >
                        +$
                        {(optionValue.upgrade_luxury_package_cost * 1).toFixed(
                          2
                        )}
                      </Typography>
                    </>
                  )}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={optionValue.upgrade_unlimited_playtime}
                        onChange={(e) => {
                          setOptionValue((prev) => ({
                            ...prev,
                            upgrade_unlimited_playtime: e.target.checked,
                            upgrade_unlimited_playtime_cost: e.target.checked
                              ? (5.99 * prev.num_kid).toFixed(2)
                              : 0,
                          }));
                        }}
                      />
                    }
                    label="Upgrade to unlimited playtime for an additional $5.99 per child"
                  />
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    gutterBottom
                    sx={{ width: "100%", textAlign: "right" }}
                  >
                    +$
                    {(optionValue.upgrade_unlimited_playtime_cost * 1).toFixed(
                      2
                    )}
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={optionValue.bring_own_food}
                        onChange={(e) => {
                          setOptionValue((prev) => ({
                            ...prev,
                            bring_own_food: e.target.checked,
                            bring_own_food_cost: e.target.checked
                              ? (49.99 * 1).toFixed(2)
                              : 0,
                          }));
                        }}
                      />
                    }
                    label="Bring your own food?"
                  />
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    gutterBottom
                    sx={{ width: "100%", textAlign: "right" }}
                  >
                    +$
                    {(optionValue.bring_own_food_cost * 1).toFixed(2)}
                  </Typography>
                </Stack>
              </Box>

              <Box width="100%" height="100%" marginTop="30px">
                <Stack>
                  <Stack
                    direction="column"
                    //   alignItems="center"
                    //   justifyContent="flex-start"
                    marginBottom="20px"
                  >
                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label="Party Date"
                      //   defaultValue={dayjs()}
                      value={selectedValue.party_date}
                      onChange={(e) => {
                        setOptionValue((prev) => ({
                          ...prev,
                          party_date: e,
                        }));
                      }}
                      sx={{
                        width: "140px",
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider> */}
                    <Typography
                      variant="subtitle1"
                      component="h2"
                      gutterBottom
                      sx={{ width: "100%", textAlign: "left" }}
                    >
                      Party Date: {optionValue.party_date.slice(0, 10)}
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      component="h2"
                      gutterBottom
                      sx={{ width: "100%", textAlign: "left" }}
                    >
                      Party Time: {optionValue.party_time}
                    </Typography>
                  </Stack>
                  <TextField
                    name="celebrant"
                    label="Celebrant"
                    variant="standard"
                    required
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.celebrant}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        celebrant: e.target.value,
                      }));
                    }}
                  />
                  <InputLabel sx={{ marginTop: "10px" }}>Gender</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={optionValue.gender}
                    variant="standard"
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        gender: e.target.value,
                      }));
                    }}
                    label="Gender"
                    sx={{ maxWidth: "100px" }}
                  >
                    <MenuItem key={1} value={"Boy"}>
                      Boy
                    </MenuItem>
                    <MenuItem key={2} value={"Girl"}>
                      Girl
                    </MenuItem>
                  </Select>
                  <TextField
                    name="age"
                    required
                    label="Age"
                    variant="standard"
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.age}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        age: e.target.value,
                      }));
                    }}
                  />
                  <TextField
                    name="guardianName"
                    required
                    label="Parent's Name"
                    variant="standard"
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.guardian_name}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        guardian_name: e.target.value,
                      }));
                    }}
                  />
                  <TextField
                    name="phoneBumber"
                    required
                    label="Phone Number"
                    variant="standard"
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.phone_number}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        phone_number: e.target.value,
                      }));
                    }}
                  />
                  <TextField
                    name="email"
                    required
                    label="Email Address"
                    variant="standard"
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.email}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }));
                    }}
                  />

                  <TextField
                    label="Special request"
                    placeholder="Special request"
                    sx={{ maxWidth: "400px", marginTop: "40px" }}
                    multiline
                    maxRows={4}
                    variant="standard"
                    value={optionValue.special_request}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        special_request: e.target.value,
                      }));
                    }}
                  />
                  <TextField
                    name="assigned_employee"
                    required
                    label="Booking Staff"
                    variant="standard"
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.assigned_employee}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        assigned_employee: e.target.value,
                      }));
                    }}
                  />
                  <TextField
                    name="serve_party_employee"
                    required
                    label="Assigned Staff"
                    variant="standard"
                    sx={{ maxWidth: "400px", marginTop: "10px" }}
                    value={optionValue.serve_party_employee}
                    onChange={(e) => {
                      setOptionValue((prev) => ({
                        ...prev,
                        serve_party_employee: e.target.value,
                      }));
                    }}
                  />
                </Stack>
                <Stack marginTop="40px">
                  <Typography variant="subtitle1" component="h2" gutterBottom>
                    Order Detail
                  </Typography>
                  {!optionValue.twenty_off && (
                    <Typography
                      variant="subtitle1"
                      component="body1"
                      gutterBottom
                    >
                      Party Room: ${selectedValue.price}
                    </Typography>
                  )}
                  {optionValue.twenty_off && (
                    <Typography
                      variant="subtitle1"
                      component="body1"
                      gutterBottom
                    >
                      Party Room:{" "}
                      <Typography
                        component="span"
                        sx={{ textDecoration: "line-through" }}
                      >
                        ${(selectedValue.price * 1).toFixed(2)}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{ marginLeft: "20px", color: "green" }}
                      >
                        ${(selectedValue.price * 0.8).toFixed(2)}
                      </Typography>
                    </Typography>
                  )}

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={optionValue.twenty_off}
                        onChange={(e) => {
                          setOptionValue((prev) => ({
                            ...prev,
                            twenty_off: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Party Room 20% off"
                    sx={{ color: "green" }}
                  />

                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.add_numKid_cost != 0
                      ? `Add.Children: $${(
                          optionValue.add_numKid_cost * 1
                        ).toFixed(2)}`
                      : ""}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.add_numAdult_cost != 0
                      ? `Add.Adults: $${(
                          optionValue.add_numAdult_cost * 1
                        ).toFixed(2)}`
                      : ""}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.add_pizza_cost != 0
                      ? `Add.Pizza: $${(optionValue.add_pizza_cost * 1).toFixed(
                          2
                        )}`
                      : ""}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.upgrade_gummy_dragon_cost != 0
                      ? `Gummy Dragon Upgrade: $${(
                          optionValue.upgrade_gummy_dragon_cost * 1
                        ).toFixed(2)}`
                      : ""}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.upgrade_luxury_package_cost != 0
                      ? `Luxury Package Upgrade: $${(
                          optionValue.upgrade_luxury_package_cost * 1
                        ).toFixed(2)}`
                      : ""}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.upgrade_unlimited_playtime_cost != 0
                      ? `Unlimited Play Time Upgrade: $${(
                          optionValue.upgrade_unlimited_playtime_cost * 1
                        ).toFixed(2)}`
                      : ""}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="body1"
                    gutterBottom
                  >
                    {optionValue.bring_own_food_cost != 0
                      ? `Outside food and drinks: $${(
                          optionValue.bring_own_food_cost * 1
                        ).toFixed(2)}`
                      : ""}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  mt={2}
                  sx={{
                    position: "sticky",
                    bottom: "10px",
                    width: "100%",
                    height: "80px",
                    backgroundColor: "#54a6e0",
                    borderRadius: "20px",
                    boxShadow: 24,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    componTextFieldent="h2"
                    gutterBottom
                    sx={{
                      width: "100%",
                      textAlign: "left",
                      marginLeft: "20px",
                      color: "white",
                      fontSize: "14px",
                      // backgroundColor: "",
                    }}
                  >
                    Total:{" "}
                    {usdFormatter.format(
                      (
                        (optionValue.twenty_off
                          ? selectedValue.price * 0.8
                          : selectedValue.price * 1) +
                        optionValue.add_numAdult_cost * 1 +
                        optionValue.add_numKid_cost * 1 +
                        optionValue.add_pizza_cost * 1 +
                        optionValue.upgrade_gummy_dragon_cost * 1 +
                        optionValue.upgrade_luxury_package_cost * 1 +
                        optionValue.upgrade_unlimited_playtime_cost * 1 +
                        optionValue.bring_own_food_cost * 1
                      ).toFixed(2)
                    )}{" "}
                    <br />
                    (Not includes tax, tips, and service fee)
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{ width: "100px", marginRight: "10px" }}
                  >
                    Finish
                  </Button>
                </Stack>
              </Box>
            </Box>
          </Modal>
        </div>
      )}
    </div>
  );
}
